<form [formGroup]="getFormGroup()">
  <div class="item rounded freight-payer-grid p-2">
    <div class="row">
      <div class="p-2">
        <div class="mb-2 mogo-header-2 text-start p-2 border-bottom">
          Job Information
        </div>
      </div>
    </div>
    <div class="row mb-1 m-2">
      <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="freight-payer-search">Freight Payer:</label>
      <div class="col-9">
        <ng-select id="freight-payer-search" class="mb-1 required" [items]="freightPayers" bindLabel="name"
          placeholder="Select Freight Payer" bindValue="clienteleId" dropdownPosition="bottom"
          formControlName="freightPayer">
          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
            <div class="text-md-start">
              {{ item.name }}
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="row mb-1 m-2">
      <label class="col-3 mt-2 text-start mogo-bold" for="pickup-close-input">Required Completion
        Date:</label>
      <div class="col-9">
        <div class="row">
          <div class="col-12">
            <div class="input-group">
              <input class="form-control required" placeholder="Required Completion Date" name="dp"
                formControlName="requiredCompletionDate" removeNgbDpDefaultValidation ngbDatepicker
                #pickupCloseDatePicker="ngbDatepicker" id="pickup-close-date-input" />
              <button class="btn btn-outline-secondary py-1" (click)="pickupCloseDatePicker.toggle()"
                [disabled]="lockdown" type="button">
                <ng-icon name="bootstrapCalendarFill" size></ng-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-1 m-2">
      <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="customer-reference-input">Loading Service Promise
        (LSP):</label>
      <div class="col-9">
        <ng-select class="mb-1 required" [items]="servicePromiseOptions" bindLabel="name" bindValue="servicePromiseId"
          placeholder="Select LSP Value" dropdownPosition="bottom" formControlName="loadingServicePromise">
        </ng-select>
      </div>
    </div>
    @if(lspSpecificDateRequired){
    <div class="row mb-1 m-2">
      <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="customer-reference-input">Job LSP Time:</label>
      <div class="col-9">
        <bryntum-time-field cls="w-100" [value]="getLspTime()"
          (onChange)="onLspTimeChange($event)"></bryntum-time-field>
      </div>
    </div>
    }
    <div class="row mb-1 m-2">
      <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="customer-reference-input">Delivery Service Promise
        (DSP):</label>
      <div class="col-9">
        <ng-select class="mb-1 required" [items]="servicePromiseOptions" bindLabel="name" bindValue="servicePromiseId"
          placeholder="Select DSP Value" dropdownPosition="bottom" formControlName="deliveryServicePromise">
        </ng-select>
      </div>
    </div>
    @if(dspSpecificDateRequired){
    <div class="row mb-1 m-2">
      <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="customer-reference-input">Job DSP Time:</label>
      <div class="col-9">
        <bryntum-time-field cls="w-100" [value]="getDspTime()"
          (onChange)="onDspTimeChange($event)"></bryntum-time-field>
      </div>
    </div>
    }
    <div class="row mb-1 m-2">
      <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="customer-reference-input">Estimated Hours:</label>
      <div class="col-9">
        <bryntum-duration-field #estimatedHoursInput cls="w-100" unit="hour" allowedUnits="hour" value="1 hour" step="0.25 h"
          [decimalPrecision]="4" (onChange)="estimatedHoursChange($event)">
        </bryntum-duration-field>

      </div>
    </div>
    <div class="row mb-1 m-2">
      <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="customer-reference-input">Priority:</label>
      <div class="col-9">
        <ng-select id="freight-payer-search" class="mb-1 required" [items]="priorityOptions" bindLabel="name"
          bindValue="jobPriorityId" placeholder="Select Priority" dropdownPosition="bottom" formControlName="priority">
        </ng-select>
      </div>
    </div>
    <div class=" row mb-1 m-2">
      <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="customer-reference-input">Order Number:</label>
      <div class="col-9">
        <input id="customer-reference-input" type="text" class="form-control required" formControlName="orderNumber"
          placeholder="Enter Order Number" />
      </div>
    </div>
    <div class="row mb-1 m-2">
      <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="customer-reference-input">Job Reference:</label>
      <div class="col-9">
        <input id="customer-reference-input" type="text" class="form-control" formControlName="jobReference"
          placeholder="Enter Job Reference" />
      </div>
    </div>
    <div class="row mb-1 m-2">
      <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="customer-reference-input">Job
        Description:</label>
      <div class="col-9">
        <input id="customer-reference-input" type="text" class="form-control" formControlName="jobDescription"
          placeholder="Enter Job Description" />
      </div>
    </div>
    <div class="row mb-1 m-2">
      <label class="col-3 mt-2 mogo-label text-start mogo-bold" for="export-order-input">Time Based:</label>
      <div class="col-1 mt-1">
        <input id="export-order-input" type="checkbox" class="" formControlName="timeBased" />
      </div>
    </div>
  </div>


</form>
